var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ImageActions } from 'app/stores/image/actions';
import { useAppDispatch } from 'app/stores/store';
import { FilePickerBase } from 'app/views/components/empty/FilePickerBase';
export const getDefaultFileSelectHandler = (dispatch) => (files, source = 'file') => {
    if (!files) {
        return;
    }
    switch (files.length) {
        case 0:
            break;
        case 1:
            dispatch(ImageActions.loadImageFile({
                data: files[0],
                source,
            }));
            break;
        default:
            dispatch(ImageActions.loadImageFiles({ files }));
            break;
    }
};
export const FilePicker = (props) => {
    const { children } = props, otherProps = __rest(props, ["children"]);
    const dispatch = useAppDispatch();
    const onSelect = React.useMemo(() => getDefaultFileSelectHandler(dispatch), [dispatch]);
    return (React.createElement(FilePickerBase, Object.assign({ onSelect: onSelect }, otherProps), children));
};
